import { CSSProperties, ReactNode } from "react"
import { Typography } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import styled from "styled-components"

// `&&` outranks antd's own .ant-typography colour
const StyledText = styled(Typography.Text)`
  && {
    display: block;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
  }

  .anticon {
    margin-right: 4px;
  }
`

/**
 * Small, muted note under a cancellation effective date picker explaining the
 * broker backdating limit. Kept quieter than an Alert, which is reserved for
 * messages that block the broker.
 */
export const BrokerBackdateNote: React.FC<IBrokerBackdateNoteProps> = ({
  children,
  style
}) => (
  <StyledText italic style={style}>
    <InfoCircleOutlined />
    {children}
  </StyledText>
)

interface IBrokerBackdateNoteProps {
  children: ReactNode
  style?: CSSProperties
}

export default BrokerBackdateNote
